
function AprobarSolicitudes(){
    return <h1>Revisar Solicitudes</h1>
}
export default AprobarSolicitudes;